/* eslint-disable */
/* tslint:disable */

import {
	AuthResponse,
	EmailParams,
	LoginParams,
	LoginTokenParams,
	RegisterParams,
	UserResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

class Auth<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Авторизация
	 * @summary Регистрация пользователя
	 * @request POST:/auth/register
	 */
	registerCreate = (data: RegisterParams, params: RequestParams = {}) =>
		this.request<UserResponse, void>({
			path: `/auth/register`,
			method: "POST",
			body: data,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Авторизация
	 * @summary Логин пользователя по email и password
	 * @request POST:/auth
	 */
	authCreate = (data: LoginParams, params: RequestParams = {}) =>
		this.request<UserResponse, void>({
			path: `/auth`,
			method: "POST",
			body: data,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Авторизация
	 * @summary Проверка аккаунта пользователя
	 * @request POST:/auth/verify
	 */
	verifyCreate = (data: EmailParams, params: RequestParams = {}) =>
		this.request<AuthResponse, any>({
			path: `/auth/verify`,
			method: "POST",
			body: data,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Авторизация
	 * @summary Обновление пароля пользователя
	 * @request POST:/auth/update
	 */
	updateCreate = (data: LoginParams, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/auth/update`,
			method: "POST",
			body: data,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Авторизация
	 * @summary Логин по токену
	 * @request POST:/auth/tk
	 */
	postAuth = (data: LoginTokenParams, params: RequestParams = {}) =>
		this.request<UserResponse, void>({
			path: `/auth/tk`,
			method: "POST",
			body: data,
			type: ContentType.Json,
			format: "json",
			...params,
		});
}
export const authAPI = new Auth();
